import React, { useMemo } from 'react';
import { useTheme } from '../../design/ThemeContext';
import '../../pages/LoginLanding.css';

const FEED_EVENTS = [
  { t:'14:42', who:'Ayşe D.',   av:'AD', clr:'#1E5FA8', verb:'tamamladı',   obj:'T-1036',  proj:'CRM', txt:'Oturum yönetimi düzeltmesi',   pill:['ok','TAMAM'] },
  { t:'14:31', who:'Mehmet K.', av:'MK', clr:'#7c3aed', verb:'taşıdı',      obj:'T-1051',  proj:'PAY', txt:'Sipariş webhook · İncelemeye', pill:['prog','İŞLEMDE'] },
  { t:'14:18', who:'Zeynep Y.', av:'ZY', clr:'#0ea5e9', verb:'yorum yaptı', obj:'T-1046',  proj:'CRM', txt:'KPI kart revizyonu',           pill:['rev','REV'] },
  { t:'14:05', who:'Can A.',    av:'CA', clr:'#16a34a', verb:'oluşturdu',   obj:'T-1054',  proj:'MOB', txt:'Push sertifikası yenileme',    pill:['new','YENİ'] },
  { t:'13:47', who:'Elif Ş.',   av:'EŞ', clr:'#db2777', verb:'onayladı',    obj:'PR-218',  proj:'WEB', txt:'Landing hero A/B varyantı',    pill:['ok','MERGE'] },
  { t:'13:22', who:'Burak Ö.',  av:'BÖ', clr:'#ea580c', verb:'paylaştı',    obj:'DOC-094', proj:'PAY', txt:'Sprint 23 retro notları',      pill:['prog','PAY'] },
  { t:'12:58', who:'Deniz A.',  av:'DA', clr:'#0891b2', verb:'kapattı',     obj:'EPIC-12', proj:'CRM', txt:'Q2 müşteri onboarding',        pill:['ok','TAMAM'] },
  { t:'12:31', who:'Seda K.',   av:'SK', clr:'#b45309', verb:'atadı',       obj:'T-1042',  proj:'CRM', txt:'Müşteri kartı arama filtresi', pill:['new','ATAMA'] },
  { t:'12:04', who:'Merve E.',  av:'ME', clr:'#be185d', verb:'güncelledi',  obj:'T-1041',  proj:'INV', txt:'Stok hareketleri pagination',  pill:['rev','REV'] },
];

function StreamEvent({ e }) {
  return (
    <div className="ll-ev">
      <div className="ll-time">{e.t}</div>
      <div className="ll-node"><span className="ll-av" style={{ background: e.clr }}>{e.av}</span></div>
      <div className="ll-body">
        <span className="ll-who">{e.who}</span>
        <span className="ll-verb"> {e.verb} </span>
        <span className="ll-obj">{e.obj}</span>
        <span className={`ll-pill ll-pill-${e.pill[0]}`}>{e.pill[1]}</span>
        <div className="ll-meta">
          <span className="ll-proj">{e.proj}</span>
          <span>{e.txt}</span>
        </div>
      </div>
    </div>
  );
}

export default function AuthShell({ children, banner = null }) {
  const { theme, toggleTheme } = useTheme();
  const doubledEvents = useMemo(() => [...FEED_EVENTS, ...FEED_EVENTS], []);

  return (
    <div className="ll-root">
      <div className="ll-stage">
        <section className="ll-form-side">
          <header style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between' }}>
            <div className="ll-brand">
              <img className="ll-logo" src="/onxflow_logo.png" alt="OnxFlow" />
              <div>
                <div className="ll-name">OnxFlow</div>
                <div className="ll-ver">v2.0.14</div>
              </div>
            </div>
            <button
              type="button"
              className="ll-theme-toggle"
              title="Tema"
              aria-label={theme === 'dark' ? 'Açık temaya geç' : 'Koyu temaya geç'}
              onClick={toggleTheme}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 14.5A8 8 0 019.5 4a8 8 0 1010.5 10.5z" />
              </svg>
            </button>
          </header>

          <div className="ll-form-card">
            {banner}
            {children}

            <div className="ll-footnote" style={{ marginTop:28, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
              <span>© 2026 OnxFlow</span>
              <span style={{ display:'flex', alignItems:'center', gap:12 }}>
                <a href="#gizlilik" onClick={(e) => e.preventDefault()}>Gizlilik</a>
                <a href="#sartlar" onClick={(e) => e.preventDefault()}>Şartlar</a>
                <span className="mono">TR</span>
              </span>
            </div>
          </div>

          <div style={{ height:24 }} />
        </section>

        <aside className="ll-canvas">
          <div className="ll-canvas-inner">
            <div className="ll-feed-bg" />
            <div className="ll-feed-grid" />
            <div className="ll-feed-noise" />

            <div className="ll-feed-content">
              <div className="ll-feed-head">
                <div className="ll-eyebrow">OnxFlow Platformu</div>
                <h2>Tüm ekibin <em>akışı</em><br />tek bir platformda.</h2>
                <p>Görev yönetiminden raporlamaya, otomasyondan entegrasyona — ekibinin ihtiyaç duyduğu her şey aynı arayüzde, kesintisiz.</p>

                <div className="ll-stats">
                  <div className="ll-stat"><span className="v">Modüler</span><span className="l">Yapı</span></div>
                  <div className="ll-stat"><span className="v">Otomatik</span><span className="l">Akış</span></div>
                  <div className="ll-stat"><span className="v">Analitik</span><span className="l">Veri</span></div>
                </div>
              </div>

              <div className="ll-stream-area">
                <div className="ll-stream">
                  <div className="ll-stream-track">
                    {doubledEvents.map((e, i) => <StreamEvent key={i} e={e} />)}
                  </div>
                </div>
              </div>

              <div className="ll-now-bar">
                <div className="ll-ico">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M13 2L3 14h8l-1 8 11-13h-8l0-7z" />
                  </svg>
                </div>
                <div className="ll-body">
                  <div className="ll-t">OnxFlow · Modüler İş Yönetim Platformu</div>
                  <div className="ll-s">TEK ARAYÜZ · TÜM EKİP · KESİNTİSİZ AKIŞ</div>
                </div>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
}
